// extracted by mini-css-extract-plugin
module.exports = {"main":"NewsSlider_main_1UWDO","heading":"NewsSlider_heading_3Zloy"};